import { STAGE } from "@local/utils/src/services"

const XRAY_URLS = {
  prd: "https://x.baerskintactical.com",
  stg: "https://x.baerskin.dev",
  dev: "https://x.baerskin.dev",
} as const

export const XRAY_URL = XRAY_URLS[STAGE]
